<template>
  <div
    ref="altGridTooltipContainer"
    :class="[
      'custom-tt-wrapper',
    ]"
  >
    <transition name="fade">
      <div
        v-if="false"
        class="custom-tt"
        data-original="isTooltipActive"
      >
        <span>Choose between larger or smaller images</span>
      </div>
    </transition>
  </div>
</template>

<script setup>
/* istanbul ignore file */
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';

const altGridTooltipContainer = ref(null);
const isTooltipActive = ref(false);

let tooltipTimeoutId = null;
let observerStop = null;
let hasBeenShown = false;

const INTERSECT_DELAY = 1000; // ms
const START_DELAY = 500; // ms
const DURATION = 3500; // ms

const hideTooltip = () => {
  isTooltipActive.value = false;
  if (tooltipTimeoutId) {
    clearTimeout(tooltipTimeoutId);
    tooltipTimeoutId = null;
  }
};

const showTooltip = () => {
  if (hasBeenShown) return;
  hasBeenShown = true;
  tooltipTimeoutId = setTimeout(() => {
    isTooltipActive.value = true;
    tooltipTimeoutId = setTimeout(hideTooltip, DURATION);
  }, START_DELAY);
};

onMounted(() => {
  if (altGridTooltipContainer.value) {
    const { stop } = useIntersectionObserver(
      altGridTooltipContainer.value,
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          setTimeout(() => {
            showTooltip();
            stop(); // Stop observing once the tooltip has been triggered.
          }, INTERSECT_DELAY);
        }
      },
      { threshold: 1.0 },
    );
    observerStop = stop;
  }
});

onBeforeUnmount(() => {
  hideTooltip(); // Clear timers
  if (observerStop) {
    observerStop(); // Stop the intersection observer
  }
});
</script>

<style lang="scss" scoped brand="mcom">
.custom-tt {
  background: rgba(0, 0, 0, .85);
  border-radius: 5px;
  color: $white;
  font-size: 12px;
  font-weight: 400;
  gap: 16px;
  letter-spacing: 0;
  left: calc(50% - 9px);
  line-height: 18px;
  margin-top: 5px;
  padding: 16px;
  position: absolute;
  transform: translateX(-50%);
  text-align: left;
  width: 256px;
  z-index: 4;

  &::after {
    border-bottom: .5rem solid rgba(0, 0, 0, .85);
    border-left: .375rem solid transparent;
    border-right: .375rem solid transparent;
    content: ' ';
    left: 50%;
    position: absolute;
    top: -.5rem;
    transform: translateX(-50%);
  }

  button {
    height: 35px;
    width: 35px;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
  }
}

@include breakpoint(1060px down) {
  .custom-tt {
    transform: translateX(-83%);

    &::after {
      left: 213px;
    }

    button {
      height: 44px;
      width: 44px;
    }
  }
}

@include breakpoint(medium down) {
  .custom-tt {
    top: 7px;
    transform: translateY(-50%);
    left: auto;
    right: 81px;

    &::after {
      left: auto;
      right: 50%;
      transform: translate(-50%, -138px);
      rotate: 90deg;
      top: 50%;
    }
  }
}

@include breakpoint(small) {
  .additional-grid-view {
    .custom-tt {
      right: 101px;
    }
  }
}

// animation
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
